module.exports = __webpack_public_path__ + "static/media/blogger.4465ed8e.svg";